function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.3580402,0,0,1.3580402,-2.8536266,-3.1466587)"
}, React.createElement("path", {
  d: "M 2.17806,12.7409 4.44314,6.82019 H 5.28519 L 7.69872,12.7409 H 6.80804 L 6.11956,10.9472 H 3.65484 l -0.64753,1.7937 z m 1.70201,-2.431 h 1.9989 L 5.26471,8.67042 C 5.1093,8.26676 4.97013,7.85697 4.84753,7.44207 4.77075,7.8224 4.66581,8.19759 4.5276,8.57277 Z m 4.01316,2.431 3.03807,-7.94056 h 1.1261 l 3.2377,7.94056 H 14.1024 L 13.181,10.3356 H 9.8691 L 9.00402,12.7409 H 7.89067 Z m 2.28047,-3.261 h 2.6822 L 12.0292,7.28274 C 11.8214,6.74225 11.6353,6.19359 11.4713,5.63809 11.3689,6.1469 11.2281,6.65058 11.0439,7.15426 Z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    version: 1.1
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/font-size.6e6d7b3e.svg";
export { SvgComponent as ReactComponent };